import api from "@/lib/api";

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () =>
  typeof navigator !== "undefined" &&
  (/iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

export const isStandalone = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function registration() {
  const reg = await navigator.serviceWorker.getRegistration();
  return reg || navigator.serviceWorker.register("/sw.js");
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await registration();
  return reg.pushManager.getSubscription();
}

export async function getPushStatus() {
  const sub = await currentSubscription();
  if (!sub) return { subscribed: false, topics: [] };
  const { data } = await api.post("/push/status", { endpoint: sub.endpoint });
  return data;
}

export async function enablePush(topics) {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const { data: cfg } = await api.get("/push/config");
  const reg = await registration();
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(cfg.public_key),
    });
  }
  const { data } = await api.post("/push/subscribe", { subscription: sub.toJSON(), topics });
  return data;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch { /* */ }
  await sub.unsubscribe();
}

export async function setPushTopics(topics) {
  const sub = await currentSubscription();
  if (!sub) throw new Error("not subscribed");
  const { data } = await api.put("/push/topics", { endpoint: sub.endpoint, topics });
  return data;
}
